import { Box, Button, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { CheckCircle } from '@material-ui/icons';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useBorrowerPortalMediaQueries } from '@roc/feature-app-core';
import { observer } from 'mobx-react';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'inline-flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  };
});

export const ThankYou = observer(() => {
  const { isSmallScreen } = useBorrowerPortalMediaQueries();
  const { globalStore } = useStore();
  const classes = useStyles();
  const portalName =
    globalStore.portalConfiguration?.portalConfiguration?.generalConfiguration
      ?.name || '';
  return (
    <Grid container spacing={4} className={classes.container}>
      <Box mt={3} width={'100%'}>
        <Box textAlign={'center'} margin={'auto'} maxWidth={1000}>
          <Box
            pb={2}
            fontSize={32}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            flexDirection={isSmallScreen ? 'column' : 'row'}
          >
            <CheckCircle
              style={{
                color: 'green',
                fontSize: isSmallScreen ? 60 : 40,
                marginRight: 8,
              }}
            />
            <div>Thank you for verifying your identity!</div>
          </Box>
          <Box pb={2} fontSize={20}>
            The process has been completed.
          </Box>
          <Box pb={2} fontSize={20}>
            Your information was successfully received.
          </Box>
        </Box>
      </Box>
    </Grid>
  );
});
